import { InputType } from '../helpers/bedrock-messages-helper';

export interface VoiceChatSession {
  sessionId: string | undefined;
  sendFeedback: (
    rating: string,
    content: string,
    isPositive?: boolean,
    payload?: { surveyFeedbackResponses?: Record<string, string | boolean | number | null> }
  ) => Promise<any>;
}

export interface BedrockChatSession {
  sessionId: string | undefined;
  messages: BedrockMessages[];
  startSession: (callback: () => void, solutionSelected: string, summary?: string, sessionId?: string) => void;
  sendMessage: (message: string, solutionSelected: string, contentType?: InputType) => Promise<any>;
  analyseImage: (
    message: string,
    image: { base64: string; filename?: string; mimeType?: string },
    productType?: string
  ) => Promise<any>;
  sendFeedback: (
    rating: string,
    content: string,
    isPositive?: boolean,
    payload?: { surveyFeedbackResponses?: Record<string, string | boolean | number | null> }
  ) => Promise<any>;
  markChatAsComplete: () => Promise<any>;
  recordFireSafetyCheck: (planNumber: string) => Promise<any>;
  gatherContextFromUser: (payload: {
    answers: { question: string; answer: string }[];
    answer?: string;
    productType?: string;
    brand?: string;
    modelNumer?: string;
    imageAttachEnabled?: boolean;
    sessionId?: string;
    showImageAttachment?: boolean;
  }) => Promise<any>;
  startAgentConversation: (
    summary: string,
    brand: string,
    sessionId: string,
    productType: string,
    voiceToVoiceTranscript?: string,
    voiceSessionId?: string
  ) => Promise<any>;
  continueAgentConversation: (message: string, productType: string, contentType?: InputType) => Promise<any>;
  createUploadUrlAndSave: (file: File) => Promise<any>;
  saveImageMetaData: (
    fileKey: string,
    contentType: string,
    planNumber: string,
    solution: string,
    productType: string
  ) => Promise<any>;
  getChatAssets: () => Promise<any>;
  cancel: () => void;
}

export interface BedrockMessages {
  role: 'user' | 'agent';
  sessionId: string;
  messageId?: string;
  status?: 'pending' | 'success' | 'error';
  content: {
    message: string;
    type: string;
    timestamp: string;
    image?: AttachedImage;
    audio?: string; // base64 PCM16 audio associated with this message
  };
}

export enum SmartFixUIState {
  Chat,
  Feedback,
  Idle,
}

export interface AttachedImage {
  filename: string;
  mimeType: string;
  data: string; // base64 encoded
}

export interface SelectedImage {
  file: File;
  preview: string;
}

export interface BedrockImageAnalysisUsage {
  input_tokens: number;
  cache_creation_input_tokens: number;
  cache_read_input_tokens: number;
  output_tokens: number;
}

export interface BedrockImageAnalysisContent {
  type: Record<string, unknown>;
  text: string;
}

export interface BedrockImageAnalysisResponse {
  id: string;
  type: string;
  role: string;
  model: string;
  content: BedrockImageAnalysisContent[];
  stop_reason: string;
  stop_sequence: string | null;
  usage: BedrockImageAnalysisUsage;
}

export interface ChatAsset {
  fileKey: string;
  contentType: string;
  timestamp: string;
  signedUrl: string;
}

export interface AssetResponse {
  message: string;
  assets: ChatAsset[];
  totalAssets: number;
}
